import Invoices from "@/pages/Invoices";

export default function BonsIntervention() {
    return (
        <Invoices
            fixedType="bon_intervention"
            overline="Bons d'intervention"
            title="Tous vos bons d'intervention"
            itemLabel={{ singular: "bon d'intervention", plural: "bons d'intervention" }}
        />
    );
}
